import { useStore } from "@store/index"

const useAvatarUploadedFilesGroups = (dataCategoryId: string) => {
  const { avatarUploadedFilesGroupsStore } = useStore()
  return avatarUploadedFilesGroupsStore.getCollection(dataCategoryId)
}

export default useAvatarUploadedFilesGroups
